/* =========================================================================
   ENDEX GROUP — endex-stamp.js | "File processed" moment on the join page
   window.EndexStamp.play(panel, {name, status, state, no}) -> Promise
   A record sheet slides up, the applicant's details type onto it, then a
   rubber stamp slams down with a shake and ink. Tap to skip. Plays once,
   only on a fresh join. Reduced motion or no support: resolves at once.
   ========================================================================= */
(function(){
  'use strict';
  var REDUCE=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CSS='\
.xs{position:absolute;inset:0;z-index:20;display:grid;place-items:center;background:rgba(10,10,9,.82);overflow:hidden;cursor:pointer;padding:16px}\
.xs__sheet{position:relative;width:min(440px,100%);background:#ECE6D8;color:#1C1A16;padding:26px 24px 30px;box-shadow:0 30px 60px -20px rgba(0,0,0,.6);font-family:"JetBrains Mono",ui-monospace,monospace}\
.xs__sheet::before{content:"";position:absolute;inset:8px;border:1px solid rgba(28,26,22,.25);pointer-events:none}\
.xs__hd{display:flex;justify-content:space-between;align-items:baseline;border-bottom:2px solid #1C1A16;padding-bottom:10px;margin-bottom:14px;font-size:.66rem;letter-spacing:.2em;text-transform:uppercase}\
.xs__hd b{font-family:var(--font-head,sans-serif);font-size:1.05rem;letter-spacing:-.01em}\
.xs__row{display:grid;grid-template-columns:96px 1fr;gap:10px;padding:7px 0;border-bottom:1px dashed rgba(28,26,22,.25);font-size:.72rem;letter-spacing:.12em;text-transform:uppercase}\
.xs__row span{color:rgba(28,26,22,.55)}\
.xs__row i{font-style:normal;font-weight:700;min-height:1em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
.xs__row i.is-typing::after{content:"";display:inline-block;width:.55em;height:1em;margin-left:2px;background:#1C1A16;vertical-align:-2px;animation:xsBlink .5s steps(1) infinite}\
@keyframes xsBlink{50%{opacity:0}}\
.xs__stamp{position:absolute;right:14px;bottom:18px;transform:rotate(-9deg);opacity:0;color:var(--signal,#FF5A1F);border:3px solid currentColor;padding:8px 14px 7px;text-align:center;font-family:var(--font-head,sans-serif);text-transform:uppercase;line-height:1;pointer-events:none;\
 -webkit-mask-image:radial-gradient(circle at 20% 30%,#000 55%,rgba(0,0,0,.55) 56%,#000 60%),radial-gradient(circle at 70% 70%,#000 50%,rgba(0,0,0,.6) 52%,#000 58%);-webkit-mask-composite:source-in;mask-composite:intersect}\
.xs__stamp::before{content:"";position:absolute;inset:3px;border:1px solid currentColor}\
.xs__stamp small{display:block;font-family:"JetBrains Mono",monospace;font-size:.55rem;letter-spacing:.24em;font-weight:600}\
.xs__stamp strong{display:block;font-size:2rem;font-weight:800;letter-spacing:-.02em;margin:4px 0 3px}\
.xs__ink{position:absolute;width:5px;height:5px;border-radius:50%;background:var(--signal,#FF5A1F);opacity:0;pointer-events:none}\
.xs__skip{position:absolute;bottom:10px;left:0;right:0;text-align:center;font:600 .6rem "JetBrains Mono",monospace;letter-spacing:.22em;color:rgba(244,241,234,.45);text-transform:uppercase}\
@media(max-width:420px){.xs__row{grid-template-columns:78px 1fr;font-size:.66rem}.xs__stamp strong{font-size:1.6rem}}';

  function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e;}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  var wait=function(ms){return new Promise(function(r){setTimeout(r,ms);});};

  function play(panel,d){
    if(REDUCE||!panel||!Element.prototype.animate)return Promise.resolve();
    if(!document.getElementById('xs-css')){var st=el('style');st.id='xs-css';st.textContent=CSS;document.head.appendChild(st);}
    d=d||{};
    var date=new Date().toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}).toUpperCase();
    var rows=[['Name',d.name||'—'],['Status',d.status||'—'],['State',d.state||'—'],['Filed',date],['Member no.',d.no||'Assigned']];
    var ov=el('div','xs'),sh=el('div','xs__sheet');
    ov.setAttribute('role','status');ov.setAttribute('aria-live','polite');ov.setAttribute('aria-label','Application processed');
    sh.appendChild(el('div','xs__hd','<b>ENDEX GROUP</b><span>Enlistment record</span>'));
    var vals=rows.map(function(r){var row=el('div','xs__row','<span>'+esc(r[0])+'</span><i></i>');sh.appendChild(row);return row.querySelector('i');});
    var stamp=el('div','xs__stamp','<small>File processed</small><strong>Accepted</strong><small>'+esc(date)+'</small>');
    sh.appendChild(stamp);ov.appendChild(sh);ov.appendChild(el('div','xs__skip','Tap to continue'));
    panel.appendChild(ov);

    var skipped=false,finish;
    var done=new Promise(function(r){finish=r;});
    ov.addEventListener('click',function(){skipped=true;finish();});

    setTimeout(function(){finish();},5000);   // failsafe: never trap someone behind the overlay
    (async function(){try{
      ov.animate([{opacity:0},{opacity:1}],{duration:160,fill:'both'});
      sh.animate([{transform:'translateY(60px) rotate(-2deg)',opacity:0},{transform:'translateY(0) rotate(-.6deg)',opacity:1}],{duration:420,easing:'cubic-bezier(.2,.9,.25,1)',fill:'both'});
      await wait(380);
      // type each field in turn
      for(var i=0;i<rows.length&&!skipped;i++){
        var t=String(rows[i][1]),node=vals[i];node.classList.add('is-typing');
        var step=Math.max(8,Math.min(22,240/Math.max(1,t.length)));
        for(var c=1;c<=t.length&&!skipped;c++){node.textContent=t.slice(0,c);await wait(step);}
        node.classList.remove('is-typing');await wait(60);
      }
      if(skipped)return;
      await wait(140);
      // the stamp: big and high, slams down, overshoots, settles
      stamp.animate([
        {opacity:0,transform:'rotate(-22deg) scale(2.6)'},
        {opacity:1,transform:'rotate(-8deg) scale(.92)',offset:.62},
        {opacity:1,transform:'rotate(-9deg) scale(1.03)',offset:.82},
        {opacity:1,transform:'rotate(-9deg) scale(1)'}
      ],{duration:420,easing:'cubic-bezier(.55,0,.8,.3)',fill:'both'});
      await wait(250);
      if(navigator.vibrate)try{navigator.vibrate(18);}catch(e){}
      // the thud: the sheet and the whole panel take the hit
      sh.animate([{transform:'translateY(0) rotate(-.6deg)'},{transform:'translateY(5px) rotate(-.3deg) scale(.985)'},{transform:'translateY(-1px) rotate(-.7deg)'},{transform:'translateY(0) rotate(-.6deg)'}],{duration:280,easing:'ease-out'});
      panel.animate([{transform:'translate(0,0)'},{transform:'translate(-4px,2px)'},{transform:'translate(3px,-2px)'},{transform:'translate(-1px,1px)'},{transform:'translate(0,0)'}],{duration:260});
      // ink kicked out from the stamp's edge
      var sr=stamp.getBoundingClientRect(),hr=sh.getBoundingClientRect();
      for(var k=0;k<14;k++){
        var dot=el('span','xs__ink'),a=Math.random()*Math.PI*2,rad=40+Math.random()*50,s=2+Math.random()*5;
        dot.style.left=(sr.left-hr.left+sr.width/2)+'px';dot.style.top=(sr.top-hr.top+sr.height/2)+'px';dot.style.width=dot.style.height=s+'px';
        sh.appendChild(dot);
        dot.animate([{opacity:.9,transform:'translate(0,0)'},{opacity:.75,transform:'translate('+(Math.cos(a)*rad)+'px,'+(Math.sin(a)*rad*.6)+'px)'}],{duration:260,easing:'cubic-bezier(.1,.8,.3,1)',fill:'forwards'});
      }
      await wait(1300);
      finish();
    }catch(e){finish();}})();

    return done.then(function(){
      var fade=ov.animate([{opacity:1},{opacity:0}],{duration:280,fill:'forwards'});
      sh.animate([{transform:'translateY(0) rotate(-.6deg)'},{transform:'translateY(-30px) rotate(1deg)'}],{duration:280,easing:'ease-in',fill:'forwards'});
      return new Promise(function(r){fade.onfinish=function(){ov.remove();r();};setTimeout(function(){if(ov.parentNode)ov.remove();r();},600);});
    });
  }
  window.EndexStamp={play:play};
})();
